import api from "../api";

export default {
    destroy(category) {
        return api.delete(`/central/categories/${category}`)
    },
}